<template>
    <div class="form-group col-md-6">
        <label for="inputs_email" class="mb-0"> {{ $t('email') }} </label>
        <app-input 
            id="inputs_email" 
            class="form-control" 
            type="email" 
            v-model="selected"
            :placeholder="$t('text_type_input')"  
        />
    </div>
</template>

<script>
    export default {
        name: 'emailAddress',
        props: {
            value: {
                type: [String, Number, Object],
                default: null
            },
        },
        computed: {
            selected: {
                get() {
                    return this.value;
                },
                set(newValue) {
                    this.$emit('input', newValue);
                }
            }
        }
    }
</script>
